module.exports = __webpack_public_path__ + "static/media/up-arrow.91f0b84f.svg";